var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.146H9C3.57 23.146 1.25 20.8305 1.25 15.4109V9.42246C1.25 4.00291 3.57 1.68738 9 1.68738H15C20.43 1.68738 22.75 4.00291 22.75 9.42246V15.4109C22.75 20.8305 20.43 23.146 15 23.146ZM9 3.18449C4.39 3.18449 2.75 4.82133 2.75 9.42246V15.4109C2.75 20.012 4.39 21.6489 9 21.6489H15C19.61 21.6489 21.25 20.012 21.25 15.4109V9.42246C21.25 4.82133 19.61 3.18449 15 3.18449H9Z",
    fill: "#4CB3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7397 16.6885C10.5497 16.6885 10.3597 16.6186 10.2097 16.4689C9.91969 16.1795 9.91969 15.7004 10.2097 15.411L13.2097 12.4167L10.2097 9.4225C9.91969 9.13306 9.91969 8.65398 10.2097 8.36454C10.4997 8.0751 10.9797 8.0751 11.2697 8.36454L14.7997 11.8877C15.0897 12.1772 15.0897 12.6563 14.7997 12.9457L11.2697 16.4689C11.1197 16.6186 10.9297 16.6885 10.7397 16.6885Z",
    fill: "#4CB3D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRight);
export default __webpack_public_path__ + "static/media/carousel_right.b879b68d.svg";
export { ForwardRef as ReactComponent };